import { CarCareBreadcrumbProps } from "./CarCareBreadcrumb.d"
import tw from "twin.macro"
import React, { useContext } from "react"
import { Link } from "../../atoms/Link"
import { LanguageContext } from "../../../contexts/Language"
import useTealiumEvent from "../../../hooks/Tealium/useTealiumEvent"
import { grayUnderlineAnimation } from "../../../styles/animations"

const CarCareBreadcrumb = ({
  pathname,
  fromArticle = false,
  articleTitle = null,
  articleCategory = "",
}: CarCareBreadcrumbProps) => {
  const { _ } = useContext(LanguageContext)

  //determine the breadcrumbs based on the pathname
  function createBreadcrumbs(pathname: string) {
    const pathParts = pathname.replace("/es", "").split("/").filter(Boolean)
    const breadcrumbs = pathParts.map((part, index) => {
      const link = `/${pathParts.slice(0, index + 1).join("/")}`

      const deslugify = (str?: string) => {
        if (!str) return undefined
        // Replace hyphens with spaces
        const result = str.replace(/-/g, " ")
        // Optionally, capitalize the first letter of each word
        return result.replace(/\b\w/g, char => char.toUpperCase())
      }
      let title: string | null = _(deslugify(part)!)

      // If fromArticle is true and this is the last index, set title to "Article"
      if (fromArticle && index === pathParts.length - 1) {
        title = articleTitle
      }

      return {
        title,
        slug: index < pathParts.length - 1 ? `${link}` : null,
        _key: index,
      }
    })
    return breadcrumbs
  }
  const breadcrumbs = pathname && createBreadcrumbs(pathname)

  // Tealium
  const { trackTealEvent } = useTealiumEvent()

  return (
    <ul
      className="breadcrumbs"
      css={[tw`flex align-middle flex-wrap leading-3`]}
    >
      {breadcrumbs &&
        breadcrumbs?.length > 1 &&
        breadcrumbs?.map((item, index) => (
          <div key={item?._key} css={tw`flex items-center`}>
            <Link
              to={item?.slug ? item?.slug : undefined}
              css={[
                index == breadcrumbs?.length - 1
                  ? tw`font-semibold pointer-events-none cursor-not-allowed`
                  : tw`text-gray-600  active:(text-toyotaRed)`,
                grayUnderlineAnimation,
              ]}
              analytics-id={
                fromArticle
                  ? `breadcrumbs:articles:${item?.title == "Article" ? articleTitle : item?.title?.toLowerCase()} `
                  : "breadcrumbs:articles:1"
              }
              onClick={() => {
                trackTealEvent({
                  tealium_event: "nav_click",
                  click_text: `breadcrumb subnav:${item?.title}`,
                  ...(fromArticle && { vehicle_category: [articleCategory] }),
                })
              }}
            >
              {item?.title}
            </Link>
            {index < breadcrumbs.length - 1 && (
              <span
                css={[
                  tw`mx-3 py-2 text-gray-600 pointer-events-none cursor-not-allowed`,
                ]}
              >
                {" > "}
              </span>
            )}
          </div>
        ))}
    </ul>
  )
}

export default CarCareBreadcrumb
